import { FC } from "react";
import { useStreak } from "./StreakContextType";
import { StreakStep } from "./StreakStep";

export const StreakContent: FC = () => {
  const {
    days,
    stepDetails,
    currentStep,
    themeManager,
    pendingStreakImg,
    filledStreakImg,
    checkedUponCompletion
  } = useStreak();

  const isStepActive = (index: number): boolean => {
    return days >= stepDetails[index]?.range;
  };
  const isComingSoon = (index: number): boolean => {
    return !isStepActive(index - 1) && stepDetails[index - 1] !== undefined;
  };

  return (
    <div className="q_daily_streak">
      <div
        className="q_streak_desc"
        style={themeManager.getStreakDescriptionStyles()}
      >
        {stepDetails[currentStep]?.description}
      </div>

      <div className="q_streak_steps">
        {stepDetails.map((step, index) => (
          <StreakStep
            key={index}
            step={step}
            index={index}
            isActive={isStepActive(index)}
            themeManager={themeManager}
            pendingStreakImg={pendingStreakImg}
            filledStreakImg={filledStreakImg}
            checkedUponCompletion={checkedUponCompletion}
            isComingSoon={isComingSoon(index)}
          />
        ))}
      </div>
    </div>
  );
};
